import ButtonAnalise from '@componentsNew/Button/ButtonAnalise';
import CircularProgress from '@componentsNew/CircularProgress';
import Typography from '@componentsNew/Typography';
import ContextTela from '@pages/DicasOtimizacao/telaContext';
import Nota from '@pages/MenuLateral/NotaView';
import { useContext, useEffect, useState } from '@wordpress/element';
import { MdCached, MdOutlinePublishedWithChanges } from 'react-icons/md';
import { combinarArrays } from '@hooks/UtilHooks';

export const BotaoAnalises = ({
  acaoClick = () => { },
  desabilitado = false,
  legibilidade,
  legibilidadeVozPassiva,
  legibilidadeOrtografia,
  legibilidadeGramatica,
  seoTextual,
  seoNaoTextual,
}) => {
  const [exibirRefazer, setExibirRefazer] = useState(false);
  const [analiseLegibilidade, setAnaliseLegibilidade] = useState([]);

  const { mobile, desktop } = useContext(ContextTela);

  useEffect(() => {
    setExibirRefazer(
      legibilidade?.length > 0 &&
      legibilidadeVozPassiva?.length > 0 &&
      legibilidadeOrtografia?.length > 0 &&
      legibilidadeGramatica?.length > 0 &&
      seoNaoTextual?.length > 0 &&
      seoTextual?.length > 0
    );
  }, [legibilidade, legibilidadeVozPassiva, legibilidadeOrtografia, legibilidadeGramatica, seoTextual, seoNaoTextual]);

  useEffect(() => {
    setAnaliseLegibilidade([]);
    combinarArrays(legibilidade, setAnaliseLegibilidade);
    combinarArrays(legibilidadeVozPassiva, setAnaliseLegibilidade);    
    combinarArrays(legibilidadeOrtografia, setAnaliseLegibilidade);
    combinarArrays(legibilidadeGramatica, setAnaliseLegibilidade);
  }, [legibilidade, legibilidadeVozPassiva, legibilidadeOrtografia, legibilidadeGramatica]);

  return (
    <div className={`${desktop && 'inline-flex mt-8'} self-stretch justify-between items-center`}>
      {desktop && <Typography component="h3">Dicas de otimização</Typography>}

      {mobile && (
        <div className="gap-4 mt-8">
          <Nota
            tipo={'legibilidade'}
            nota={
              analiseLegibilidade?.filter(r => r.otimizado == true).length /
              analiseLegibilidade?.length
            }
          />
          <Nota
            tipo={'SEO'}
            nota={
              (seoTextual?.filter(r => r.otimizado == true).length +
                seoNaoTextual?.filter(r => r.otimizado == true).length) /
              (seoNaoTextual?.length + seoTextual?.length)
            }
          />
        </div>
      )}

      <ButtonAnalise disabled={desabilitado} onClick={acaoClick}>
        <div className="justify-center items-center gap-2 inline-flex">
          {desabilitado && <CircularProgress />}

          {!desabilitado && exibirRefazer && <MdCached className="w-6 h-6 relative text-neutras-white" />}

          {!desabilitado && !exibirRefazer && (
            <MdOutlinePublishedWithChanges className="w-6 h-6 relative text-neutras-white" />
          )}

          <Typography component="button">
            {exibirRefazer ? 'Refazer análise do artigo' : 'Fazer análise do artigo'}
          </Typography>
        </div>
      </ButtonAnalise>
    </div>
  );
};
